// src/core/components/auth/auths.jsx  
import React from "react"  
import PropTypes from "prop-types"  
import ImPropTypes from "react-immutable-proptypes"  
  
export default class Auths extends React.Component {  
  static propTypes = {  
    errSelectors: PropTypes.object.isRequired,  
    errActions: PropTypes.object.isRequired,  
    getComponent: PropTypes.func.isRequired,  
    authSelectors: PropTypes.object.isRequired,  
    authActions: PropTypes.object.isRequired,  
    specSelectors: PropTypes.object.isRequired,  
    definitions: ImPropTypes.iterable.isRequired  
  }  
  
  constructor(props, context) {  
    super(props, context)  
  
    this.state = {}  
  }  
  
  onAuthChange =(auth) => {  
    let { name } = auth  
  
    this.setState({ [name]: auth })  
  }  
  
  submitAuth =(e) => {  
    e.preventDefault()  
  
    let { authActions, errActions, definitions } = this.props  
  
    let payload = {}  
    let hasError = false  
  
    Object.keys(this.state).forEach((key) => {  
      let auth = this.state[key]  
      if (!auth) return  
  
      // clear any previous inline validation error for this scheme  
      if (errActions) {  
        errActions.clearBy(err =>  
          !(err.get("authId") === key && err.get("source") === "validation"))  
      }  
  
      let schema = definitions.get(key)  
      let type = schema && schema.get("type")  
  
      if (type === "apiKey") {  
        // trim only leading/trailing whitespace; preserves tm_ab-cd_ef.gh and long keys  
        let trimmed = typeof auth.value === "string" ? auth.value.trim() : auth.value  
  
        if (!trimmed) {  
          hasError = true  
          if (errActions) {  
            errActions.newAuthErr({  
              authId: key,  
              source: "validation",  
              level: "error",  
              message: "API Key cannot be empty. Please enter a valid key."  
            })  
          }  
          return  
        }  
        payload[key] = Object.assign({}, auth, { value: trimmed })  
      } else {  
        payload[key] = auth  
      }  
    })  
  
    if (hasError) return  
  
    authActions.authorize(payload)  
  }  
  
  logoutClick =(e) => {  
    e.preventDefault()  
  
    let { authActions, definitions } = this.props  
    let auths = definitions.map( (val, key) => {  
      return key  
    }).toArray()  
  
    authActions.logout(auths)  
  }  
  
  close =(e) => {  
    e.preventDefault()  
    let { authActions } = this.props  
  
    authActions.showDefinitions(false)  
  }  
  
  render() {  
    let { definitions, getComponent, authSelectors, errSelectors } = this.props  
    const AuthItem = getComponent("AuthItem")  
    const Oauth2 = getComponent("oauth2", true)  
    const Button = getComponent("Button")  
  
    let authorized = authSelectors.authorized()  
  
    let authorizedAuth = definitions.filter( (definition, key) => {  
      return !!authorized.get(key)  
    })  
  
    let nonOauthDefinitions = definitions.filter( schema => schema.get("type") !== "oauth2")  
    let oauthDefinitions = definitions.filter( schema => schema.get("type") === "oauth2")  
  
    return (  
      <div className="auth-container">  
        {  
          !!nonOauthDefinitions.size && <form onSubmit={ this.submitAuth }>  
            {  
              nonOauthDefinitions.map( (schema, name) => {  
                return <AuthItem  
                  key={name}  
                  schema={schema}  
                  name={name}  
                  getComponent={getComponent}  
                  onAuthChange={this.onAuthChange}  
                  authorized={authorized}  
                  errSelectors={errSelectors}  
                  />  
              }).toArray()  
            }  
            <div className="auth-btn-wrapper">  
              {  
                nonOauthDefinitions.size === authorizedAuth.size ? <Button className="btn modal-btn auth" onClick={ this.logoutClick }>Logout</Button>  
              : <Button type="submit" className="btn modal-btn auth authorize">Authorize</Button>  
              }  
              <Button className="btn modal-btn auth btn-done" onClick={ this.close }>Close</Button>  
            </div>  
          </form>  
        }  
  
        {  
          oauthDefinitions && oauthDefinitions.size ? <div>  
            {  
              definitions.filter( schema => schema.get("type") === "oauth2")  
                .map( (schema, name) =>{  
                  return (<div key={ name }>  
                    <Oauth2 authorized={ authorized }  
                            schema={ schema }  
                            name={ name } />  
                  </div>)  
                }  
                ).toArray()  
            }  
          </div> : null  
        }  
  
      </div>  
    )  
  }  
}



// WEBPACK FOOTER //
// ./src/core/components/auth/auths.jsx